export default __webpack_public_path__ + "static/media/tresky-logo.9d148dd3.jpg";